import React, { useEffect, useState } from 'react';

import Button, { models } from 'components/core/Button';
import Modal from 'components/layout/Modal';
import Icon, { names } from 'components/core/Icon';

import { useTranslation } from 'react-i18next';
import { zIndex } from 'config/constants';
import { debounce } from 'utils/debounce';
import { paths } from 'config/routes/constants';
import listenEvents from './helpers/listenEvents';
import shouldSessionExpire from './helpers/shouldSessionExpire';
import { events, thirtyMinutes } from './constants';

import {
  Container,
  Title,
  Text,
} from './styles';

export default function ExpiredSession() {
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const { t } = useTranslation();
  const handleExit = () => {
    window.location.replace(paths.login);
  };
  useEffect(() => {
    if (process.env.REACT_APP_IS_DEMO) return;
    if (shouldSessionExpire()) {
      const debouncedLogOut = debounce(() => {
        setShouldShowModal(true);
        window.sessionStorage.clear();
        window.localStorage.clear();
      }, thirtyMinutes);

      debouncedLogOut();
      listenEvents(events, () => debouncedLogOut());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      zIndex={zIndex.lvMax}
      canClose={false}
      blurBackground
      show={shouldShowModal}
    >
      <Container>
        <Title>
          <Icon name={names.warning} width="35px" height="35px" />
          <h2>{t('expiredSession')}</h2>
        </Title>
        <Text>
          {t('text.expiredSession')}
        </Text>
        <Button
          type="button"
          margin="0 auto"
          onClick={() => handleExit()}
          text="OK"
          model={models.modelB}
        />
      </Container>
    </Modal>
  );
}
